"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Validator = require("./Classes/Validator");

var PsValidation = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Vue.mixin({
      data: function data() {
        return {
          validator: null
        };
      },
      methods: {
        // initialize the validator
        $initValidator: function $initValidator() {
          var sfc = this;
          this.validator = new _Validator.Validator(sfc);
        },
        // renders the validator error (by model).
        $error: function $error(model) {
          return this.validator ? this.validator.renderError(model) : null;
        }
      } //mounted() {
      //this.$initValidator();
      //}

    });
  }
};
var _default = PsValidation;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@primitivesocial/ps-validation/dist/index.js
// module id = QhTJ
// module chunks = 0 1